import React, { Component } from 'react'
import { observer } from 'mobx-react'
import Material from  '../Material'
import AnswerAnalysis from '../Material/AnswerAnalysis'
import styles from  './questions.css'

@observer(['practiceStore'])
export default class RadioQuestion extends Component {
  handleClickChecked (e){
    const { practiceStore, questionIndex, answer } = this.props
    const value = e.target.value
    const userAnswer = practiceStore.userAnswer.toJSON()

    userAnswer[questionIndex].answer = value
    userAnswer[questionIndex].isCorrect = parseInt(value, 10) === parseInt(answer, 10)
    practiceStore.saveAnswer(userAnswer);
  }

  // 阻止label标签左右快捷键冲突
  preventKey(e) {
    if (e.keyCode === 37) {     // 左键 上一题
      e.preventDefault();
    } else if (e.keyCode === 39) {  // 右键 下一题
      e.preventDefault();
    }
  }

  renderChoice() {
    const { practiceStore, choices, answer, questionIndex } = this.props
    const radioUserAnswer = practiceStore.userAnswer.toJSON()
    const highlight = practiceStore.show.answer

    return choices.map((item, index) => {
      let checked = radioUserAnswer[questionIndex]
                    ? parseInt(radioUserAnswer[questionIndex].answer, 10) === index
                    : false

      let highlightClass = ''
      if (highlight) {
        let isCorrect = answer === index
        if (isCorrect) {
          highlightClass = styles.highlight
        } else {
          if (checked) {
            highlightClass = styles.error
          }
        }
      }

      return (
        <li key={`${practiceStore.id}${questionIndex}${index}`}>
          <label htmlFor={`radioQuestion${questionIndex}${index}`} onKeyDown={ e => this.preventKey(e)}>
            <input
              type='radio'
              id={`radioQuestion${questionIndex}${index}`}
              name={`select-choice${questionIndex}`}
              defaultChecked={ checked }
              value={ index }
              onChange={ e => this.handleClickChecked(e) }
            />
          <span className={ highlightClass }>
            { String.fromCharCode(index + 65) } . {item}
          </span>
          </label>
        </li>
      );
    })
  }

  render() {
    const { practiceStore, question, answer_analysis, category } = this.props
    return (
      <div>
        <Material stem={ question } category={category}/>
        <ul className={ styles.radio }>
          { this.renderChoice() }
        </ul>
        { practiceStore.show.answer ?
          <AnswerAnalysis analysisAnswer={ answer_analysis } />
          : null
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Practice/Question/RadioQuestion.js
 **/